import { ComponentProps } from "react";

export function DottedRoundSpinner(props: ComponentProps<"svg">) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 52 52"
      fill="none"
      {...props}
    >
      <g
        clipPath="url(#clip0_7444_2967)"
        fillRule="evenodd"
        clipRule="evenodd"
        fill="var(--color-primary-500)"
      >
        <path
          opacity={0.21}
          d="M19.668 4.93c-.278.077-.55.167-.824.266a2.005 2.005 0 01-2.54-1.243 1.996 1.996 0 011.243-2.54c.322-.115.641-.22.966-.314a2.013 2.013 0 012.499 1.335 2.004 2.004 0 01-1.344 2.495z"
        />
        <path
          opacity={0.25}
          d="M26.489 3.997c-.294-.001-.576-.01-.864.002a2.01 2.01 0 01-2.037-1.973c-.018-1.1.87-2.01 1.97-2.027.338-.005.677-.01 1.021-.002a1.996 1.996 0 011.949 2.049 1.982 1.982 0 01-2.04 1.951z"
        />
        <path
          opacity={0.28}
          d="M35.81 4.001a1.987 1.987 0 01-2.55 1.227l-.817-.268a1.987 1.987 0 01-1.328-2.497 1.991 1.991 0 012.495-1.319c.164.044.326.096.487.15.162.052.323.105.482.168a1.991 1.991 0 011.23 2.54z"
        />
        <path
          opacity={0.3}
          d="M42.139 8.106a2.01 2.01 0 01-2.81.384c-.225-.179-.457-.339-.695-.512a1.982 1.982 0 01-.488-2.78 1.996 1.996 0 012.783-.498c.283.198.553.402.822.606a2.003 2.003 0 01.388 2.8z"
        />
        <path
          opacity={0.33}
          d="M46.865 13.971c-.91.628-2.151.4-2.782-.502a11.353 11.353 0 00-.506-.702 2.004 2.004 0 01.394-2.807 2.013 2.013 0 012.804.403c.206.268.4.542.592.826.627.91.409 2.155-.502 2.782z"
        />
        <path
          opacity={0.38}
          d="M49.567 21.013a2.005 2.005 0 01-2.496-1.344c-.08-.269-.167-.55-.266-.824a2.005 2.005 0 011.243-2.54 1.997 1.997 0 012.539 1.243c.115.322.221.641.314.966a2.013 2.013 0 01-1.334 2.499z"
        />
        <path
          opacity={0.42}
          d="M49.95 28.537a2 2 0 01-1.948-2.049c-.002-.284.01-.575-.001-.863a1.995 1.995 0 011.97-2.027 1.99 1.99 0 012.03 1.96c.004.338.01.676.002 1.021a2.006 2.006 0 01-2.053 1.958z"
        />
        <path
          opacity={0.55}
          d="M50.867 33.614l-.318.97A2.006 2.006 0 0148 35.81a1.987 1.987 0 01-1.227-2.55l.268-.817a1.987 1.987 0 012.498-1.328 2.006 2.006 0 011.328 2.498z"
        />
        <path
          opacity={0.65}
          d="M47.3 40.928c-.198.282-.402.552-.606.822a1.995 1.995 0 01-2.8.387 2.01 2.01 0 01-.384-2.81c.179-.225.339-.457.512-.695a1.994 1.994 0 012.78-.488 1.996 1.996 0 01.498 2.784z"
        />
        <path
          opacity={0.7}
          d="M41.635 46.774a15.63 15.63 0 01-.826.593 1.988 1.988 0 01-2.782-.502c-.627-.91-.4-2.151.502-2.782.242-.163.476-.328.702-.506a2.004 2.004 0 012.807.394 2.013 2.013 0 01-.403 2.803z"
        />
        <path
          opacity={0.8}
          d="M34.453 50.586c-.322.116-.64.221-.966.315a2.013 2.013 0 01-2.498-1.335 2.004 2.004 0 011.344-2.495c.278-.078.55-.167.824-.267a2.006 2.006 0 012.54 1.243 1.996 1.996 0 01-1.244 2.54z"
        />
        <path d="M26.443 52.001c-.338.005-.676.01-1.021.002a1.996 1.996 0 01-1.949-2.049 1.986 1.986 0 012.04-1.951c.29.01.575.01.863-.002a2.01 2.01 0 012.037 1.973c.018 1.1-.87 2.01-1.97 2.027z" />
        <path
          opacity={0.05}
          d="M20.885 49.538a2.006 2.006 0 01-2.498 1.327l-.97-.317a2.006 2.006 0 01-1.227-2.55 1.994 1.994 0 012.55-1.226l.817.267a1.994 1.994 0 011.328 2.498z"
        />
        <path
          opacity={0.07}
          d="M13.856 46.802a1.996 1.996 0 01-2.784.498c-.282-.198-.552-.402-.822-.606a2.003 2.003 0 01-.387-2.8 2.01 2.01 0 012.81-.384c.225.179.453.348.695.512a1.986 1.986 0 01.488 2.78z"
        />
        <path
          opacity={0.09}
          d="M8.03 42.04a2.013 2.013 0 01-2.804-.403 15.647 15.647 0 01-.592-.826 1.996 1.996 0 01.501-2.782c.91-.628 2.152-.4 2.782.502.163.242.328.475.507.702a2.004 2.004 0 01-.394 2.807z"
        />
        <path
          opacity={0.11}
          d="M3.953 35.695a1.988 1.988 0 01-2.54-1.243c-.115-.322-.22-.64-.314-.966a2.013 2.013 0 011.335-2.499 2.004 2.004 0 012.495 1.345c.077.277.167.549.267.824a2.005 2.005 0 01-1.243 2.539z"
        />
        <path
          opacity={0.13}
          d="M2.027 28.412A1.995 1.995 0 010 26.442c-.005-.338-.01-.676-.002-1.021a1.996 1.996 0 012.049-1.949 1.994 1.994 0 011.952 2.04c-.002.294-.01.575 0 .863a2.01 2.01 0 01-1.972 2.037z"
        />
        <path
          opacity={0.19}
          d="M13.468 7.917c-.243.162-.48.338-.703.506a2.004 2.004 0 01-2.807-.394 2.013 2.013 0 01.404-2.804c.267-.206.541-.4.825-.592a1.996 1.996 0 012.782.502c.628.91.4 2.151-.501 2.782z"
        />
        <path
          opacity={0.15}
          d="M5.228 18.738l-.268.817a1.987 1.987 0 01-2.498 1.328 2.006 2.006 0 01-1.328-2.498l.318-.969A2.006 2.006 0 014 16.189a1.987 1.987 0 011.227 2.55z"
        />
        <path
          opacity={0.17}
          d="M8.49 12.672c-.178.226-.342.467-.511.695A2 2 0 114.7 11.072c.198-.282.402-.552.606-.822a1.99 1.99 0 012.797-.378 1.995 1.995 0 01.387 2.8z"
        />
      </g>
      <defs>
        <clipPath id="clip0_7444_2967">
          <path fill="#fff" d="M0 0H52V52H0z" />
        </clipPath>
      </defs>
    </svg>
  );
}
